import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import { ProvedorSessao } from './sessao.tsx';
import { ProvedorAmbiente } from './ambiente.tsx';
import { App } from './App.tsx';
import './estilos.css';
import './tema-hub.css';

createRoot(document.getElementById('raiz')!).render(
  <StrictMode>
    <ProvedorAmbiente>
      <ProvedorSessao>
        <App />
      </ProvedorSessao>
    </ProvedorAmbiente>
  </StrictMode>,
);
